import { getActiveDetail, getActiveDetailBatch } from "~/api";
import { createActivePageBatchQueue } from "~/utils/activePageBatchQueue";

const loaderByFetch = new WeakMap();

function createLoader($fetch, headers) {
  return createActivePageBatchQueue(async (references) => {
    try {
      return await getActiveDetailBatch(references, $fetch, headers);
    } catch (batchError) {
      // 灰度期间旧环境可能尚未发布批量接口，回退后仍保持原有渲染能力。
      const responses = await Promise.all(
        references.map((reference) => getActiveDetail(
          {
            ...reference,
            pageNo: 1,
            pageSize: 1,
            getCache: 0,
          },
          $fetch,
          headers,
        )),
      );

      return {
        data: {
          dataList: responses.flatMap((response) => response?.data?.dataList || []),
        },
      };
    }
  });
}

export function loadActivePageInBatch(reference, $fetch, headers = {}) {
  if (typeof $fetch !== "function") {
    throw new TypeError("loadActivePageInBatch requires a fetch function");
  }

  let loader = loaderByFetch.get($fetch);
  if (!loader) {
    loader = createLoader($fetch, headers);
    loaderByFetch.set($fetch, loader);
  }

  return loader.load(reference);
}
